import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/announcement_selection_email/`, data);
};

const postDocument = async (data) => {
  return await httpClient.post(`/announcement_selection_email/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const filter = async (query) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/announcement_selection_email${query}`,
  );
};

const sendMassRejectEmail = async (announcement_id, announcement_rol_id) => {
  return await httpClient.post(
    '/announcement_selection_email/send_all_rejected/',
    {
      convocatoria: announcement_id,
      convocatoria_rol: announcement_rol_id,
    },
  );
};

export { post, postDocument, filter, sendMassRejectEmail };
